import { ComplaintsPage } from 'components/template/complaints';
import { ssrApi } from 'api/ssr';
import { IComplaint } from 'constants/types';

export default function Complaints({
  complaints,
}: {
  complaints: IComplaint[];
}) {
  return <ComplaintsPage complaints={complaints} />;
}

export async function getServerSideProps() {
  const { results } = await ssrApi.complaints.list({ limit: 20 });

  return {
    props: { complaints: results },
  };
}
